import { render, staticRenderFns } from "./printVarietyBtn.vue?vue&type=template&id=54fdfa9a&"
import script from "./printVarietyBtn.vue?vue&type=script&lang=js&"
export * from "./printVarietyBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports